<template>
  <!-- Thin wrapper over PrimeVue Tag. It's the design system's public API for tags. Forwards every
       prop, event and slot; theming/defaults live in preset.js. Use this, not primevue/tag. -->
  <Tag v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Tag>
</template>

<script setup>
import Tag from 'primevue/tag';

defineOptions({ inheritAttrs: false });
</script>
